export default __webpack_public_path__ + "static/media/alur-4.c5ad097b.png";